import React, { useRef, useEffect } from 'react';
import Box from '@material-ui/core/Box';
import Tabs from '@material-ui/core/Tabs';
import { Tab } from '@material-ui/core/';
import Airplane from '../../assets/icons/Airplane.svg';
import AirplaneActive from '../../assets/icons/AirplaneActive.svg';
import Car from '../../assets/icons/Car.svg';
import CarActive from '../../assets/icons/CarActive.svg';
import Bus from '../../assets/icons/Bus.svg';
import BusActive from '../../assets/icons/BusActive.svg';
import Bed from '../../assets/icons/Bed.svg';
import BedActive from '../../assets/icons/BedActive.svg';
import BigWheelActive from '../../assets/icons/bigWheelActive.svg';
import BigWheel from '../../assets/icons/bigWheel.svg';
import PackageActive from '../../assets/icons/packageActive.svg';
import Package from '../../assets/icons/package.svg';
import Carousel from '../../assets/icons/Carousel.svg';
import CarouselActive from '../../assets/icons/CarouselActive.svg';

import * as S from './styles';

import FlySearchInputs from './FlySearchInputs';
import HotelSearchInputs from './HotelSearchInputs';
import CarSearchInputs from './CarSearchInputs';
import BusSearchInputs from './BusSearchInputs';
import ExperiencesSearchInputs from './ExperiencesSearchInputs';
import { useGlobal } from '../../contexts/globalContext';
import EntertainmentSearchInputs from './EntertainmetSearchInputs';
import { getCampaignColors } from '../../utils/getCampaignColors';
import { useTheme } from '@material-ui/core';
import PackageSearchInputs from './PackageSearchInputs';

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	const campaignColors = getCampaignColors();
	const theme = useTheme();

	const getDynamicStyles = () => {
		const baseStyles = {};

		baseStyles.backgroundColor =
			campaignColors.searchColor || theme.palette.primary.main;

		return baseStyles;
	};

	return (
		<S.TabPanel
			role='tabpanel'
			hidden={value !== index}
			id={`full-width-tabpanel-${index}`}
			aria-labelledby={`full-width-tab-${index}`}
			{...other}
			style={getDynamicStyles()}
		>
			{value === index && (
				<Box p={3}>
					<div>{children}</div>
				</Box>
			)}
		</S.TabPanel>
	);
}

const SearchBar = () => {
	const [value, setValue] = React.useState(0);
	const { user } = useGlobal();
	const tabActions = useRef();

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const campaignColors = getCampaignColors();
	const theme = useTheme();

	let arr = [];
	user?.campaign?.campaignConfigLayout?.flight &&
		arr.push({
			type: 'Aéreo',
			iconActive: AirplaneActive,
			icon: Airplane,
			component: <FlySearchInputs />,
		});
	user?.campaign?.campaignConfigLayout?.hotel &&
		arr.push({
			type: 'Hotel',
			iconActive: BedActive,
			icon: Bed,
			component: <HotelSearchInputs />,
		});
	// Exclusivos vem depois de Hotel (ordem do Figma)
	user?.campaign?.campaignConfigLayout?.experience &&
		arr.push({
			// type: "Experiências",
			type: 'Exclusivos',
			iconActive: BigWheelActive,
			icon: BigWheel,
			component: <ExperiencesSearchInputs />,
		});
	user?.campaign?.campaignConfigLayout?.car &&
		arr.push({
			type: 'Carro',
			iconActive: CarActive,
			icon: Car,
			component: <CarSearchInputs />,
		});
	user?.campaign?.campaignConfigLayout?.bus &&
		arr.push({
			type: 'Rodoviário',
			iconActive: BusActive,
			icon: Bus,
			component: <BusSearchInputs />,
		});
	user?.campaign?.campaignConfigLayout?.entertainment &&
		arr.push({
			// type: "Entretenimento",
			type: 'Experiências',
			iconActive: CarouselActive,
			icon: Carousel,
			component: <EntertainmentSearchInputs />,
		});

	user?.campaign?.campaignConfigLayout?.packageTour &&
		arr.push({
			type: 'Pacotes',
			iconActive: PackageActive,
			icon: Package,
			component: <PackageSearchInputs />,
		});

	useEffect(() => {
		setValue(0);
	}, []);

	const injectDynamicStyles = (styles) => {
		const existingStyle = document.getElementById('dynamic-tab-styles');
		if (existingStyle) {
			existingStyle.remove();
		}

		const styleElement = document.createElement('style');
		styleElement.id = 'dynamic-tab-styles';
		styleElement.className = 'dynamic-tab-styles';
		let cssText = '';

		if (styles.active) {
			cssText += `
				.Tabs-control .active {
					background-color: ${styles.active.backgroundColor} !important;
					color: ${styles.active.color} !important;
				}
				.Tabs-control .active .MuiTab-wrapper {
					color: ${styles.active.color} !important;
				}
			`;
		}

		if (styles.muiTabsIndicator) {
			cssText += `
				.MuiTabs-indicator {
					background-color: ${styles.muiTabsIndicator.backgroundColor} !important;
					left:
				}
			`;
		}

		styleElement.textContent = cssText;
		document.head.appendChild(styleElement);
	};

	// Usage in your component
	useEffect(() => {
		const dynamicStyles = {
			active: {
				backgroundColor: campaignColors.searchColor || theme.palette.primary.main,
				color: theme.palette.secondary.white || '#FFF',
			},
			muiTabsIndicator: {
				backgroundColor: campaignColors.searchColor || theme.palette.primary.main,
			},
		};

		injectDynamicStyles(dynamicStyles);

		return () => {
			const styleElement = document.getElementById('dynamic-tab-styles');
			if (styleElement) {
				styleElement.remove();
			}
		};
	}, [campaignColors, theme]);

	useEffect(() => {
		setTimeout(() => {
			if (tabActions.current) {
				tabActions.current.updateIndicator();
			}
		}, 200);
	}, [campaignColors, theme]);

	return (
		<S.Wrapper id="search-bar">
			<Tabs
				value={value}
				onChange={handleChange}
				className='Tabs-control'
				indicatorColor='secondary'
				action={tabActions}
				variant='scrollable'
				scrollButtons='on'
			>
				{arr.map((x, index) => (
					<Tab
						label={x.type}
						className={`Tab-label ${value === index && 'active'}`}
						key={x.type}
						icon={
							<img
								className='Tab-image'
								src={value === index ? x.iconActive : x.icon}
								alt={x.type}
							/>
						}
					/>
				))}
			</Tabs>
			{arr.map((x, index) => (
				<TabPanel value={value} index={index} key={x.type}>
					{x.component}
				</TabPanel>
			))}
		</S.Wrapper>
	);
};

export default SearchBar;
